import { Pdvinfo } from '../../../domain/models/PdvInfo';

export interface PdvInfoStateInterface {
  pdvInfo: Pdvinfo
}

export class pdvInfoState implements PdvInfoStateInterface {
  pdvInfo: Pdvinfo;
  constructor({
    pdvInfo = new Pdvinfo({})
  }: PdvInfoStateInterface) {
    this.pdvInfo = pdvInfo;
  }
}